export default __webpack_public_path__ + "static/media/FilteringMaps.52240774.mp4";